import { Grid, IconButton } from "@mui/material"
import { theme } from "src/providers/ThemeProvider"
import { ErrorIcon, LocationIcon, Text } from "src/shared"

const PlaceholderSelectItem = () => {
  return (
    <Grid
      container
      flexWrap="nowrap"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item>
        <Grid container alignItems="center" gap={1}>
          <LocationIcon />
          <Text
            sx={{
              wordBreak: "break-word",
              whiteSpace: "initial",
              [theme.breakpoints.down(600)]: {
                fontSize: 20,
                lineHeight: "24px",
              },
            }}
            fontWeight={700}
            lineHeight="31.65px"
          >
            Chọn cửa hàng đổi quà
          </Text>
        </Grid>
      </Grid>
      <Grid item>
        <IconButton
          sx={{
            padding: 0,
            "&:hover": {
              backgroundColor: "inherit",
            },
          }}
        >
          <ErrorIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default PlaceholderSelectItem
